module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/login/forgot-password-dialog/forgot-password-dialog.component.css
// module id = ./src/app/components/login/forgot-password-dialog/forgot-password-dialog.component.css
// module chunks = main